// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const rewardDetails = "RewardDetails__rewardDetails__h1q8P";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const zeroState = "RewardDetails__zeroState__Or4T1";